/**
 * 会员信息
 */
import React from 'react';

import { Input, Row, Col, DatePicker, Select } from 'antd';

import PageLayout from '../../ui/PageLayout';


import OrgSelect from '../../ui/OrgSelect';

class AccountRecordIndex extends React.Component {

    columns = [{
        title: '流水号',
        dataIndex: 'serialNo',
        width: '10%',
    }, {
        title: '业务类型',
        dataIndex: 'operateType',
        width: '10%',
        format: { 1: '商户充值', 2: '商户退款', 3: '个人服务收款' }
    }, {
        title: '金额',
        dataIndex: 'amount',
        width: '8%',
    }, {
        title: '发票号码',
        dataIndex: 'invoiceNumber',
        width: '10%',
    }, {
        title: '交款人',
        dataIndex: 'payer',
        width: '10%',
    }, {
        title: '交款人证件号',
        dataIndex: 'payerCreditNo',
        width: '10%',
    }, {
        title: '操作人',
        dataIndex: 'operator',
        width: '8%',
    }, {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: '10%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '10%',
    }];

    state = {
        visible: false,
        loadData: '',
        queryData: {},
    };

    inputSearch = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    selectChange = (value) => {
        let { queryData } = this.state;
        queryData["operateType"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="流水号/发票号"
                                    onSearch={this.inputSearch.bind(this, "serialNo")}
                                    enterButton
                                    style={{ width: 250 }}
                                />
                                <Input.Search
                                    placeholder="交款人"
                                    onSearch={this.inputSearch.bind(this, "payer")}
                                    enterButton
                                    style={{ width: 250, marginLeft: '10px', marginRight: '10px' }}
                                />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <Select onChange={this.selectChange} allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option key={"1"}>商户充值</Select.Option>
                                    <Select.Option key={"2"}>商户退款</Select.Option>
                                    <Select.Option key={"3"}>个人服务收款</Select.Option>
                                </Select>
                                <OrgSelect style={{ width: '200px', marginLeft: '10px' }} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {/* <Button type="primary" onClick={this.add}>导出</Button> */}
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/accountRecord/findAccountRecordPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
            </div>
        )
    }
}

export default AccountRecordIndex;